import { useSyncExternalStore } from 'react';
import deviceStore from '../shared/deviceStore';

/**
 * A hook to access the global device store.
 * It provides the current enabled camera and microphone,
 * along with functions to update them.
 */
export const useDeviceStore = () => {
  const enabledCam = useSyncExternalStore(
    deviceStore.subscribe,
    deviceStore.getEnabledCam,
    deviceStore.getEnabledCam,
  );

  const enabledMic = useSyncExternalStore(
    deviceStore.subscribe,
    deviceStore.getEnabledMic,
    deviceStore.getEnabledMic,
  );

  return {
    enabledCam,
    enabledMic,
    setEnabledCam: deviceStore.setEnabledCam,
    setEnabledMic: deviceStore.setEnabledMic,
  };
};
